import environment from '@environment';
import { CheckCompany, CreateCompanyDTO, CreateTicketDTO, CustomerEmailResult, CustomerNumberSearch, SetCustomerDTO } from 'core/models/freshdesk/freshdeskresponse.dto';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';

export class FreshDeskService {
  private static apiBuilder = new EndpointHelper(`${environment.FRESHDESK_URL}`);

  static async getContactsSearch(customerNumber?: string): Promise<CustomerNumberSearch> {
    const url = this.apiBuilder.createUrl('search')
      .addRouteParam('contacts')
      .addQueryParam('query', `"customer_number:${customerNumber}"`)
      .build();

    const res = await HttpClient.GetInstance.get<CustomerNumberSearch | any>(url);
    return (
      res?.data as CustomerNumberSearch
    );
  }

  static async getContactEmail(emailAddress?: string): Promise<CustomerEmailResult[]> {
    const url = this.apiBuilder.createUrl()
      .addRouteParam('contacts')
      .addQueryParam('email', `${emailAddress}`)
      .build();

    const res = await HttpClient.GetInstance.get<CustomerEmailResult | any>(url);
    return (
      res?.data as unknown as CustomerEmailResult[]
    );
  }

  static async getCompanies(customerNumber?: string): Promise<CheckCompany> {
    const url = this.apiBuilder.createUrl('companies')
      .addRouteParam('autocomplete')
      .addQueryParam('name', `${customerNumber}`)
      .build();

    const res = await HttpClient.GetInstance.get<any | any>(url);
    return res?.data;
  }

  static async setContact(contactId?: number | null, payLoad?: any): Promise<SetCustomerDTO> {
    const url = this.apiBuilder.createUrl('contacts')
      .addRouteParam(`${contactId}`)
      .build();

    const res = await HttpClient.GetInstance.put<any, SetCustomerDTO>(url, JSON.stringify(payLoad));
    return res?.data;
  }

  static async createCompany(customerNumber?: string): Promise<CreateCompanyDTO> {
    const contactCompany = {
      name: customerNumber
    };

    const url = this.apiBuilder.createUrl('companies')
      .build();

    const res = await HttpClient.GetInstance.post<any, CreateCompanyDTO>(url, JSON.stringify(contactCompany));
    return res?.data;
  }

  static async createTicket(payLoad?: any): Promise<boolean> {
    const url = this.apiBuilder.createUrl('tickets')
      .build();

    const res = await HttpClient.GetInstance.post<any, boolean>(url, JSON.stringify(payLoad)).catch(err => Promise.resolve(false));
    return !!res;
  }
}